import React from "react";
import "../App.css";

function Navbar() {
  return (
    <div className="navbar">
      <img src="/euro_logo_2.jpg" alt="euro 2024 logo" height="100px"></img>
      <h1>Bennett Crew Sweepstake 2024</h1>
    </div>
  );
}

export default Navbar;
